import { useLocale, useTranslations } from 'next-intl';
import type messages from '@/src/messages/en.json';

type LabelKey = keyof typeof messages.listingLabels;

const labelKeys: Record<string, LabelKey> = {
  'monthly base rent': 'baseRent',
  'base rent': 'baseRent',
  'administration fee': 'administrationFee',
  'administrative fee': 'administrationFee',
  'admin fee': 'administrationFee',
  'application fee': 'applicationFee',
  deposit: 'deposit',
  'holding fee': 'holdingFee',
  'cat rent': 'catRent',
  'dog rent': 'dogRent',
  'pet fee': 'petFee',
  cat: 'cat',
  dog: 'dog',
  storage: 'storage',
  house: 'house',
  property: 'property',
  kitchen: 'kitchen',
  laundry: 'laundry',
  climate: 'climate',
  'interior features': 'interiorFeatures',
  connectivity: 'connectivity',
  'outdoor spaces': 'outdoorSpaces',
  'scenic views': 'scenicViews',
  parking: 'parking',
  facilities: 'facilities',
  'pet facilities': 'petFacilities',
  security: 'security',
  'fitness and sports': 'fitnessAndSports',
  'social and work spaces': 'socialAndWorkSpaces',
  services: 'services',
  'community type': 'communityType',
  'special features': 'specialFeatures',
  'lease terms': 'leaseTerms',
  'pet policy': 'petPolicy',
  'parking policy': 'parkingPolicy',
  'utilities included': 'utilitiesIncluded',
  smoking: 'smoking',
  furnishing: 'furnishing',
  dishwasher: 'dishwasher',
  'garbage disposal': 'garbageDisposal',
  'ceiling fan': 'ceilingFan',
  'availability 24 hours': 'availability24Hours',
  'in unit': 'inUnitLaundry',
  'in-unit laundry': 'inUnitLaundry',
  'shared laundry': 'sharedLaundry',
};

export function useListingLabel() {
  const locale = useLocale();
  const t = useTranslations('listingLabels');
  return (label: string, group?: string): string => {
    if (locale !== 'es') return label;
    const normalized = label.trim().toLowerCase();
    if (group === 'Laundry' && normalized === 'shared') return t('sharedLaundry');
    const key = Object.hasOwn(labelKeys, normalized) ? labelKeys[normalized] : undefined;
    return key ? t(key) : label;
  };
}
